<template>
  <div
    class="c-requestOutlineRow"
    :class="{ 'c-requestOutlineRow-applicationStatus': type === 'application_status' }"
  >
    <div class="c-requestOutlineRow_col c-requestOutlineRow_icon">
      <div>
        <coconala-icon :name="icon" />
      </div>
    </div>
    <div class="c-requestOutlineRow_col c-requestOutlineRow_heading">
      <div>{{ heading }}</div>
    </div>
    <div class="c-requestOutlineRow_col c-requestOutlineRow_content">
      <div
        v-if="type === 'budget'"
        class="c-requestOutlineRowContent"
      >
        <DRequestPrice
          :price-min="contents.priceMin"
          :price-max="contents.priceMax"
        />
        <br class="isSP" />
        <span
          class="c-requestOutlineRowContent_withholding"
          v-if="isShowWithholding"
        >
          （源泉徴収：あり）詳細は<a
            :href="$coconala.helpURL('/articles/900000102266')"
            target="_blank"
            rel="noopener"
          >こちら</a>
        </span>
      </div>

      <div
        v-if="type === 'remaining_days'"
        class="c-requestOutlineRowContent"
      >
        <span v-if="contents.isExpired || !contents.expireDate">
          <span class="c-requestOutlineRowContent_emphasis">募集終了</span>
        </span>
        <span v-else>
          あと
          <span v-if="calcRemainingDays > 0">
            <span class="c-requestOutlineRowContent_emphasis">{{ calcRemainingDays }}</span>
            日 と
            <span class="c-requestOutlineRowContent_emphasisSmall">{{ calcRemainingHours }}時間</span>
          </span>
          <span v-else-if="calcRemainingHours > 0">
            <span class="c-requestOutlineRowContent_emphasis">{{ calcRemainingHours }}時間</span>
          </span>
          <span v-else>
            <span class="c-requestOutlineRowContent_emphasis">1時間未満</span>
          </span>
          <br class="isSP" />
        </span>
        <span class="c-requestOutlineRowContent_additional">
          <span v-if="contents.expireDate">
            締切日 {{ $util.dayjs.unix(contents.expireDate).format('LL') }}
            <br class="isSP" />
            <span class="isPC"> / </span>
          </span>
          掲載日 {{ $util.dayjs.unix(contents.created).format('LL') }}
        </span>
      </div>

      <div v-if="type === 'delivery_dates'">
        <span v-if="contents.deliveryDate">
          {{ $util.dayjs.unix(contents.deliveryDate).format('LL') }}
        </span>
        <span v-else>
          ご相談
        </span>
      </div>

      <div
        v-if="type === 'application_status'"
        class="c-requestOutlineRowContent c-applicationStatus"
      >
        <div class="c-applicationStatusLeft">
          <div class="c-applicationStatusLeft_col">
            <span>提案人数</span>
            <br class="isSP" />
            <span class="c-requestOutlineRowContent_emphasis c-requestOutlineRowContent_emphasis-proposals">
              {{ $util.numberWithDelimiter(contents.applicationStatus.offerCount) }}
            </span>
          </div>
          <div class="c-applicationStatusLeft_col">
            <span>契約人数</span>
            <br class="isSP" />
            <span class="c-requestOutlineRowContent_emphasis c-requestOutlineRowContent_emphasis-contracts">
              {{ $util.numberWithDelimiter(contents.applicationStatus.contractCount) }}
            </span>
          </div>
        </div>
        <dl class="c-applicationStatusRight">
          <dt>閲覧数</dt>
          <dd>{{ $util.numberWithDelimiter(contents.applicationStatus.viewCount) }}</dd>
        </dl>
        <div class="c-applicationStatusBottom">
          <a
            href="#"
            v-scroll-to="{ el: '#requestContentsProposers', offset: scrollToOffset }"
            v-if="contents.applicationStatus.offerCount"
          >
            <coconala-icon name="chevron-down" /> 提案者一覧を見る
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import DRequestPrice from '~/components/molecules/DS2/DRequestPrice'

export default {
  name: 'OutlineRow',
  components: {
    DRequestPrice
  },
  props: {
    icon: {
      type: String
    },
    heading: {
      type: String
    },
    contents: {
      type: Object,
      default: () => {}
    },
    type: {
      type: String
    },
    scrollToOffset: {
      type: Number
    },
    isConfirm: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    calcRemainingMilliSeconds() {
      return this.$util.dayjs
        .unix(this.contents.expireDate)
        .set({
          hour: 23,
          minute: 59,
          second: 59
        })
        .diff(this.$util.dayjs())
    },
    calcRemainingDays() {
      return Math.floor(this.$util.dayjs.duration(this.calcRemainingMilliSeconds).asDays())
    },
    calcRemainingHours() {
      return this.$util.dayjs.duration(this.calcRemainingMilliSeconds).hours()
    },
    isShowWithholding() {
      return this.contents.withholdingFlag && (this.isConfirm || !this.user.corporateFg)
    }
  }
}
</script>
<style lang="scss" scoped>
a {
  @include link-effect;
}

@media (min-width: breakpoint(Requests, M)) {
  .isSP {
    display: none;
  }
}

@media (max-width: breakpoint(Requests, M) + 1) {
  .isPC {
    display: none;
  }
}

.c-requestOutlineRow {
  display: flex;
  height: 44px;
  border-bottom: 1px solid $color-gray-50;

  &-applicationStatus {
    margin-bottom: 20px;
    height: 60px;
    border-bottom: none;

    .c-requestOutlineRow_icon {
      padding-top: 2px;

      align-items: baseline;
    }

    .c-requestOutlineRow_heading {
      padding-top: 8px;

      align-items: baseline;
    }
  }

  &_col {
    display: flex;

    align-items: center;
  }

  &_icon {
    color: $color-gray-700;
    font-size: 20px;

    flex-basis: 32px;
    justify-content: center;

    .coconala-icon {
      position: relative;
      bottom: 2px;
    }
  }

  &_heading {
    font-weight: bold;

    flex-basis: 120px;
  }
}

/deep/ .d-requestPrice {
  &_emphasis {
    font-weight: bold;
    font-size: 18px;
  }
}

.c-requestOutlineRowContent {
  &_emphasis {
    font-weight: bold;
    font-size: 18px;

    &-contracts,
    &-proposals {
      font-size: 14px;
    }
  }

  &_emphasisSmall {
    margin-right: 4px;
  }

  &_withholding,
  &_additional {
    margin-left: 12px;
    font-size: 12px;
  }
}

.c-applicationStatus {
  display: flex;

  flex-wrap: wrap;
}

.c-applicationStatusLeft {
  display: flex;

  &_col {
    & + & {
      margin-left: 8px;
    }
  }
}

.c-applicationStatusRight {
  display: flex;
  margin-left: 32px;
  padding-top: 2px;
  font-size: 12px;

  dt + dd {
    margin-left: 4px;
  }

  dd + dt {
    margin-left: 16px;
  }
}

.c-applicationStatusBottom {
  margin-top: 4px;
  min-height: 20px;
  width: 100%;
  font-size: 13px;
}

@media (max-width: breakpoint(Requests, M)) {
  .c-requestOutlineRow {
    padding: 4px 0;
    min-height: 30px;
    height: auto;
    font-size: 12px;

    &-applicationStatus {
      position: relative;
      margin-bottom: 8px;
      padding-bottom: 28px;
    }

    .c-requestOutlineRow_icon {
      padding-top: 2px;

      align-items: normal;
    }

    .c-requestOutlineRow_heading {
      padding-top: 3px;

      align-items: normal;
    }

    .c-requestOutlineRow_content {
      padding-top: 3px;

      align-items: normal;
    }

    &_icon {
      flex: 0 0 20px;
      font-size: 14px;

      .coconala-icon {
        bottom: 0;
      }
    }

    &_heading {
      flex: 0 0 80px;
    }

    &_content {
      flex: 0 1 auto;
    }
  }

  /deep/ .d-requestPrice {
    &_emphasis {
      font-size: 13px;
    }
  }

  .c-requestOutlineRowContent {
    &_emphasis {
      font-size: 13px;

      &-contracts,
      &-proposals {
        color: $color-gray-900;
        font-size: 12px;
      }
    }

    &_withholding {
      margin: 0;
      font-size: 11px;
    }

    &_additional {
      display: block;
      margin: 3px 0;
      color: $color-gray-700;
      font-size: 10px;
      line-height: 13px;
    }
  }

  .c-applicationStatus {
    margin-right: 0;
  }

  .c-applicationStatusLeft {
    &_col {
      text-align: center;

      & + & {
        margin-left: 20px;
      }
    }
  }

  .c-applicationStatusRight {
    position: absolute;
    right: 0;
    bottom: 0;
    margin-left: 0;
    padding-top: 4px;
    width: calc(100% - 100px);
    border-top: 1px solid $color-gray-50;
  }

  .c-applicationStatusBottom {
    min-height: 0;
    font-size: 12px;
  }
}
</style>
